'use client';

import { createContext, useContext } from 'react';

import { type PickerMode, type RoutingPath, type WorkflowNodeData } from './types';

export type WorkflowCallbacks = {
  onOpenPicker: (nodeId: string, mode: PickerMode) => void;
  onOpenConfig: (nodeId: string) => void;
  onDeleteNode: (nodeId: string) => void;
  onEdgeInsert: (edgeId: string, position: { x: number; y: number }) => void;
  onAddRoutingPath: (nodeId: string, path: RoutingPath) => void;
  onRemoveRoutingPath: (nodeId: string, pathId: string) => void;
  // Adds a ranked supplier branch: a routing path + a connected SupplierPayout node.
  onAddSupplierBranch: (routingNodeId: string) => void;
  onUpdateNodeData: (nodeId: string, data: Partial<WorkflowNodeData>) => void;
};

const WorkflowContext = createContext<WorkflowCallbacks | null>(null);

export const WorkflowCallbacksProvider = WorkflowContext.Provider;

export function useWorkflowCallbacks(): WorkflowCallbacks {
  const ctx = useContext(WorkflowContext);
  if (ctx == null) {
    throw new Error('useWorkflowCallbacks must be used within WorkflowCallbacksProvider');
  }
  return ctx;
}
